const TYPES = {
    addstore:"add store",
    removestore:"removes store",
    addProduct:"add product",
    removeProduct:"remove product" 
}

export default TYPES;